import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await login(email.trim().toLowerCase(), password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-white min-h-screen text-[#09090B]">
      <SiteHeader />
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="border-2 border-[#09090B] bg-white p-8 ws-hard-shadow">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#09090B] text-white flex items-center justify-center">
              <Lock strokeWidth={2.5} className="w-5 h-5" />
            </div>
            <div>
              <div className="ws-label text-[#FF5A00]">/ Admin</div>
              <h1 className="font-display font-black text-2xl tracking-tighter">Safety Team Login</h1>
            </div>
          </div>

          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="ws-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
                className="mt-2 w-full border-2 border-[#09090B] bg-white px-4 py-3 focus:border-[#FF5A00] outline-none font-medium"
                required
              />
            </div>
            <div>
              <label className="ws-label" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
                className="mt-2 w-full border-2 border-[#09090B] bg-white px-4 py-3 focus:border-[#FF5A00] outline-none font-medium"
                required
              />
            </div>
            {error && (
              <div
                data-testid="admin-login-error"
                className="border-2 border-[#DC2626] bg-[#FEE2E2] text-[#DC2626] px-4 py-3 ws-label"
              >
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#FF5A00] hover:bg-[#E65100] text-white font-bold px-6 py-3 ws-label border-2 border-[#09090B] ws-hard-shadow disabled:opacity-60"
            >
              {submitting ? "Signing in…" : "Sign In"}
              {!submitting && <ArrowRight strokeWidth={2.5} className="w-4 h-4" />}
            </button>
          </form>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
